import React, {useCallback} from 'react';
import styled from "styled-components";
import ScoreWrapper from "../../../../BestContent/BestSection/ScoreWrapper";
import {useTranslation} from "react-i18next";
import {isAram} from "../../../../../../../../function";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
`;

const RankBox = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const RankText = styled.span`
  font-weight: 500;
  font-size: 12px;
  color: ${props => props.checkAway ? props.theme.color.red_300 : props.theme.color.dark_200};
`;
const HeaderImage = styled.img`
  width: 16px;
  height: 16px;
`;
const ScoreBox = styled.div`
    cursor: pointer;
`;
const AiTableContent = ({aiScore, rank, isAce, isMvp, onClick, data, checkAway = true, gameType,onClickRankGraph,puu_id,hoverScale,map}) => {
    const {t} = useTranslation();


    const getRank = useCallback((rank) => {
        if (rank) {
            return t('summoner.grade', {count: rank, ordinal: true});
        }
    }, [])

    return (
        <>
            <Wrapper>
                <ScoreBox onClick={(e) => onClickRankGraph(e,puu_id)}>
                    <ScoreWrapper
                        hoverScale={hoverScale}
                        noneClickable={isAram(gameType,map)}
                        data={data}
                        onClick={isAram(gameType,map) ? () => {
                        } : onClick}
                        fontSize={16}
                        score={checkAway ? 0 : aiScore}
                        paddingHorizontal={8}
                    />
                </ScoreBox>
                <RankBox>
                    {!checkAway && isAce && <HeaderImage src={'images/ico_best_player04.svg'}/>}
                    {!checkAway && isMvp && <HeaderImage src={'images/ico_best_player01.svg'}/>}
                    <RankText checkAway={checkAway}>{checkAway ? t('tags.escape') : rank + getRank(rank)}</RankText>
                </RankBox>
            </Wrapper>
        </>
    );
};

export default React.memo(AiTableContent);
